export default(state = {
    directionVelocity: 3,
    distance: 4,
    far: 1024,
    fov: 60,
    gravity: 9.81 / 2,
    height: 1.618,
    initialY: 512,
    jumpVelocity: 1,
    maxGravity: 54 / 2,
    mouseSpeed: 0.002
}, action) => {
    switch (action.type) {
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/portfolio/battle-royale/reducers/player.js